import React from 'react'
//import { Link } from 'react-router-dom'
import { HashLink as Link} from 'react-router-hash-link'
import { isAuthenticated, logout, isAuthorized } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import AceEditor from 'react-ace';

import 'brace/mode/java';
import 'brace/theme/monokai';


export default class GettingStarted extends React.Component{

  logout() {
    logout()
    this.setState({ loggedOut: true })


  }


render() {
let email;
let authenticationParams = {redirectUri: "${authenticationParams.redirectUri}",
clientId: "authenticationParams.clientId"}

  return (
  <div>

      <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/updates'>Updates</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>


        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>


      <div className="App-banner">

        <span className="orange-bold">  NEWFORMA CONNECTED </span> 

      </div>
      <div className="content2">

        <div className="content-wrap-no-padding">

        <div className="left-col">
        <h1 className="left-col-heading">GUIDES</h1>
        <ul className="left-col-ul">
          <li><a className="doc-link-welcome" href="#introduction">Authentication</a></li>
          <li><a className="doc-link" href="#service">Service to Service Auth</a></li>
          <li><a className="doc-link" href="#user">User to Service Authentication</a></li>
          { isAuthorized() ? (<li><a className="doc-link" href="#contructex">ContructEx Authentication</a></li>) : ''}
          <li><a className="doc-link" href="#example">Code Examples</a></li>

        </ul>

        </div>

        <div className="right-col">
          <p id="introduction"></p>
        <h1 className="introduction-header-welcome">Authentication</h1>
        <p className="introduction-p-italic">
        01000101 01101110 01100101 01110010 01100111 01101001 01111010 01100101 00100001
      </p>
        <hr className="short-hr"></hr>
        <p className="introduction-p">
          Go through this section to learn how to set up Authentication with Newforma so that you can access your resources via Newforma's APIs. Currently explain two types
          of authentication Service to Service and User to Service. The desired behavior of the integration or app you are building will dictate which type of authencation
          you should setup. The code for both scenarios will be very similar
        </p>

        <h1 className='sub-introduction-header'>Local Domain Authentication</h1>
        <p className="introduction-p">
         Check back soon for updates!
        </p>

        <h1 className='sub-introduction-header'>Single User Scenario</h1>
        <p className="introduction-p">
         Is your app similar to any of the following:
        </p>

        <ul className="docs-ul">
            <li>Indvidual users will use the app to access project data specific to themselves.</li>

            <li>A project manager, building owner or team lead is going to run an app to generate a custom report.</li>

            <li>You have added a Newforma API feature (project search) to an intranet site that requires user login.</li>
        </ul>
        <p className="introduction-p">
         If any of the above fit your desired behavior of the app you are building you will want to setup Single User Authentication.
        </p>

        <h1 className='sub-introduction-header'>Service to Service Scenario</h1>
        <p className="introduction-p">
         If you are working on a scenario where you need a background server task to periodically pull or update data in a Newforma
         resource without user interaction please see our Service to Service section.
        </p>
    { isAuthorized() ? (<div>
        <h1 className='sub-introduction-header'><span className="orange">*NEW</span> ConstructEx Authentication</h1>

        <p className="introduction-p">
         Looking to use our ContructEx APIs, authenticaiton is easy. First you will need to take care of one pre-requisite which is submit a
         request to Newforma to be granted API access. Once this is complete you will be able to call the /auth/tokens endpoint to receive an
         Authorization Token which will be used for all other ConstructEx endpoints.
        </p></div>)

: '' }

        {/*-----------Single User------------------------ */}
        <hr className="full-hr"></hr>

        <h1 className="introduction-header">Service to Service Authentication</h1>
        <div className="targetHelperGettingStarted" id="service"></div>
        <hr className="short-hr"></hr>

        <p className="introduction-p">
          Newforma uses Azure Active Directory to authenticate users in our Newforma Project Center and Cloud environment, for short
          Newforma Cloud. The first step is to use these credentials to log into our Cloud Web Portal:
        </p>
        <ul className="getting-started-ul">
            <li>1. If your company has setup +Cloud log into <a href="https://newforma.cloud">https://newforma.cloud</a>.</li>

            <li>2. The rop right you will find the name of the user you logged in as with a drop down arrow.</li>

            <li>3. In that menu choose GENERATE SERVICE ACCESS KEY.</li>

            <li>4. You will be brought to a page that displays your Access Key and Secret.</li>

            <li>5. Store these somewhere reliable. Once you leave the page you will not be able to retrieve them again.</li>

        </ul>

        <p className="introduction-p">
          Newforma has provided an Authentication Sample App which can be used to demonstrate the process of accessing our /login endpoint and then it will display
          a list of projects from the /projects endpoint. The sample has been written in JavaScript using Node.js and the AWS JS SDK.
        <br />
        <br />
          There are a few pre-requisites before you can run the example code. Please install Node.js and npm. Node.js is a JavaScript runtime built on Chrome's V8 JavaScript Engine.
          Node.js uses an event-driven, non-blocking I/O model that makes it lightweight and efficient. The node package manager (npm) is a command line interface program
          that manages node.js libraries. <br />
          To install both of these tools you can visit <a href='https://www.npmjs.com/get-npm'>npmjs.com</a>. Click on the "Download Node.js and npm" button. After
          the installation is complete test your install with the commands <span className="italic">node -v</span> and <span className="italic">npm -v</span>.

        </p>

        <h1 className='sub-introduction-header'>1. Download or clone the Authentication Example code git repository.</h1>
        <p className='introduction-p'>
          With your favorite git client or code editor <a href="https://github.com/nsellers/newforma-authentication-sample.git"> clone </a>
           the Authenitcation repository. If you prefer you can download it directly,
          <a href="https://github.com/nsellers/newforma-authentication-sample/archive/master.zip"> Zip Direct Download</a>. If you download directly unzip to an easy
          to find location.

        </p>

        <h1 className='sub-introduction-header'>2. Setup your Node Packages.</h1>
        <p className='introduction-p'>
          Open a command prompt (Windows) or terminal (Mac) and browse to the folder containing the sample code. Run <span className="italic">npm install</span>, this
          will download all appropriate Node packages needed to run this app.
        </p>

        <h1 className='sub-introduction-header'>3. Setup your parameters.</h1>
        <p className='introduction-p'>
          Open the <span className='italic'>authProvider.js</span> file found in "src" folder. Here you will need to replace the values for <span className='italic'>accesskey</span>
          and <span className='italic'>secret</span>.
        </p>

        <h1 className='sub-introduction-header'>4. Run your build.</h1>
        <p className='introduction-p'>
          Open a command prompt (Windows) or terminal (Mac) and browse to the folder <span className="italic">you unzipped to</span>. Run <span className="italic">node script.js</span>,
          this will run the app with your previously specified parameters. If this is successful you will see: <br /> <br />
          <span className="italic">&#123;"items":[&#123;"id":"5ef3db2d-a7da-3a5f-4de3-6748ed35e608","name":"Building Project","number":"1234.01","npcServer":"NPCS_ServerName"&#125;,&#123;"id"...</span>

          <br />
          <br />
          at the bottom of your console.
        </p>


        {/*-----------Service to Service------------------------ */}
        <hr className="full-hr"></hr>

        <h1 className="introduction-header" >Single User Authentication</h1>
        <div className="targetHelperGettingStarted" id="user"></div>
        <hr className="short-hr"></hr>

        <p className="introduction-p">
          User to service authentication is very similar to service to service, the only difference is that you will need to setup your app to request
          and users Access Key and Secret to be dynamically placed into the properties in the <span className='italic'>authProvider.js</span> file found in "src" folder of the sample app.
          Once the user is authenticated you will then be able to make calls to our Hybrid APIs which have been designed for the individual user context.
        </p>


        {/*-----------ContructEx------------------------ */}
      {isAuthorized() ? ( <div> <hr className="full-hr"></hr>


        <h1 className="introduction-header" >ContructEx Authentication</h1>

        <div className="targetHelperGettingStarted" id="user"></div>
        <hr className="short-hr"></hr>

        <p className="introduction-p">
          ContructEx will be using an auth token based authentication. To begin integrating your app please use the steps below.
        </p>

        <h1 className='sub-introduction-header'>1. Contact Newforma to become a ConstructEx API User.</h1>
        <p className='introduction-p'>
          Simply send us an <a href="mailto:nsellers@newforma.com?Subject=ContructEx%20API%20Request" target="_top">email </a> with your
          Name, Company Name and Project Name(s) that you would like to use our APIs with.
        </p>

        <h1 className='sub-introduction-header'>2. Make a call to /auth/tokens.</h1>
        <p className='introduction-p'>
          Make a call to the /auth/tokens endpoint with the body:<br/><br/>

          <span className="italic">&#123;"payload": &#123;"clientId":"user@domain.com","clientSecret":"password"&#125;&#125;</span>

        </p>


        <h1 className='sub-introduction-header'>2. Use auth token in all other requests.</h1>
        <p className='introduction-p'>
          Once you receive the token you can then use it to make calls to all other ContructEx API endpoints.
        </p>  </div>) : '' }

        {/*-----------Code Examples------------------------ */}

        <hr className="full-hr"></hr>

        <h1 className="introduction-header" >Code Examples</h1>
        <div className="targetHelperGettingStarted" id="example"></div>
        <hr className="short-hr"></hr>


        <p className="introduction-p">
          In this section you can review the three JavaScript files that make up the Authentication Sample Code. This code was written using
          Node.js and can be run on Windows or Mac machines. This example will log in a user and then complete a request to the Newforma Enteprise API /Projects endpoints.
          Understanding how this example functions will give a blueprint to write the same functionality in another language if necessary. The three files are
          <span className='italic'>authProvider.js</span>, <span className='italic'>awsRequest.js</span> and <span className='italic'>script.js</span>.
          To access this sample please download it directly from here, <a href="https://github.com/nsellers/newforma-authentication-sample.git">Sample </a>
          or clone or download it from <a href="https://github.com/nsellers/newforma-authentication-sample/archive/master.zip">GitHub</a>.

        </p>
        <h1 className='sub-introduction-header'>authProvider.js</h1>
        <div className="parent">
          <AceEditor
            className="editor"
            height="700px"
            width="90%"
            mode="javascript"
            theme="monokai"
            name="awsRequest"
            id="ace"
            onLoad={this.onLoad}
            onChange={this.onChange}
            fontSize={14}
            showPrintMargin={false}
            readOnly={true}
            showGutter={true}
            highlightActiveLine={true}
            value={`
"use strict";
const fetch = require("node-fetch");
class authentication{
  constructor(){}


login(url){
return fetch(url, {
    method : "POST",
    headers: {
      "Content-Type" : "application/json"
    },
    body : JSON.stringify({
        accessKey : 'KEY',
        secret : 'SECRET'
    })
}).then(response => {
if(response.status == 200){
  return response.json();
}else {
  return Promise.reject(new error("Failed to login!"));
}
});

}

}

exports.authentication = authentication;
`}
              setOptions={{
              enableBasicAutocompletion: false,
              enableLiveAutocompletion: false,
              enableSnippets: false,
              showLineNumbers: true,
              tabSize: 2,
              scrollSpeed: 1,
              useWorker: false
              }}
              />
        </div>

  <h1 className='sub-introduction-header'>awsRequest.js</h1>

        <div className="parent">
          <AceEditor
            className="editor"
            height="700px"
            width="90%"
            mode="javascript"
            theme="monokai"
            name="azureSeleniumAuthenticationProvider"
            id="ace"
            onLoad={this.onLoad}
            onChange={this.onChange}
            fontSize={14}
            showPrintMargin={false}
            readOnly={true}
            showGutter={true}
            highlightActiveLine={true}
            value={`
  "use strict";
  Object.defineProperty(exports, "__esModule", { value: true });
  const aws4 = require("aws4");
  const https = require("https");
  class awsRequest {
      constructor(awsRegion) {
          this.awsRegion = awsRegion;
      }
      setCommonOptions(options) {
          options.service = options.service || "execute-api";
          options.region = options.region || this.awsRegion;
      }
      request(options, tokens) {
          this.setCommonOptions(options);
          const signedOptions = aws4.sign(options, {
            secretAccessKey: tokens.secretAccessKey,
            accessKeyId: tokens.accessKeyId,
            sessionToken: tokens.sessionToken
          });
          return this.makeRequest(signedOptions);
      }
      makeRequest(options) {
          const promise = new Promise((resolve, reject) => {
              const request = https.request(options, (response) => {
                  const body = [];
                  response.on('data', (chunk) => {
                      body.push(chunk);
                  });
                  response.on('end', () => {
                      response.body = body.join('');
                      resolve(JSON.parse(response.body));
                  });
              });
              if (options.body) {
                  request.write(options.body);
              }
              request.on('error', (err) => {
                  reject(err);
              });
              request.end();
          });
          return promise;
      }
  }
  exports.awsRequest = awsRequest;
              `}
              setOptions={{
              enableBasicAutocompletion: false,
              enableLiveAutocompletion: false,
              enableSnippets: false,
              showLineNumbers: true,
              tabSize: 2,
              scrollSpeed: 1,
              useWorker: false
              }}
              />
            </div>


  <h1 className='sub-introduction-header'>script.js</h1>

            <div className="parent">
              <AceEditor
                className="editor"
                height="700px"
                width="90%"
                mode="javascript"
                theme="monokai"
                name="index"
                id="ace"
                onLoad={this.onLoad}
                onChange={this.onChange}
                fontSize={14}
                showPrintMargin={false}
                readOnly={true}
                showGutter={true}
                highlightActiveLine={true}
                value={`
const loginURL = "https://api.newforma.cloud/v1/login";
const awsRequest_1 = require("./awsRequest");
const authProvider_1 = require("./authProvider");
const options ={
  hostname: "enterprise.api.newforma.cloud",
  protocol: 'https:',
  path: '/v1/projects',
  method: "GET"
};

const awsRegion = "us-east-1";
const authHttps = new awsRequest_1.awsRequest(awsRegion);
const authProvider = new authProvider_1.authentication();

const searchAuthHttps = new awsRequest_1.awsRequest(awsRegion);
const searchAuthProvider = new authProvider_1.authentication();

authProvider.login(loginURL).then((result) => {
  let tokens ={
    accessKeyId: result.accessKeyId,
    secretAccessKey: result.secretAccessKey,
    sessionToken: result.sessionToken
  }
  console.log(tokens);
  return tokens;
}).then((generatedTokens) => {
  authHttps.request(options, generatedTokens).then((myProjects) =>{
    console.log(JSON.stringify(myProjects));
    return generatedTokens;
  })
})
                `}
                  setOptions={{
                  enableBasicAutocompletion: false,
                  enableLiveAutocompletion: false,
                  enableSnippets: false,
                  showLineNumbers: true,
                  tabSize: 2,
                  scrollSpeed: 1,
                  useWorker: false
                  }}
                  />
                </div>

        </div>

        </div>


      </div>

</div>)}}



/** WEBPACK FOOTER **
 ** ./src/pages/GettingStarted/index.js
 **/